import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

const CompletedIcon = ({
  color = '#3F3F3F',
}: Props) => (
  <Svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <Path
      d="M18.3281 6L7.32812 17L2.32812 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M22.3281 10L14.8281 17.5L13.3281 16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default CompletedIcon;
